export default __webpack_public_path__ + "static/media/lipstick-bright-spring.e82e092e.png";